const cedSftpUser = {
  type: 'ConnectEd',
  key: 'ced_sftp_user',
  value: ''
};

export default cedSftpUser;



// WEBPACK FOOTER //
// ./app/models/cedSftpUser.js